import PropTypes from "prop-types";
import React, { Fragment, useState, useEffect, useContext } from "react";
import { multilanguage } from "redux-multilanguage";
import { connect } from "react-redux";
import { setCurrency } from "../../redux/actions/currencyActions";
import LanguageCurrencyChanger from "./sub-components/LanguageCurrencyChanger";
import { AuthContext } from "../../common/Auth"

const HeaderTop = ({
  currency,
  setCurrency,
  currentLanguageCode,
  dispatch,
  borderStyle,
  themeClass
}) => {
  const { themeSettingsData } = useContext(AuthContext)
  const [headerTopData, setHeaderTopData] = useState([])

  useEffect(() => {
    if (themeSettingsData && themeSettingsData.length > 0) {
      themeSettingsData.map((i) => {
        if (i.settingsName === "headerTopMenu") {
          setHeaderTopData(i.values[0]);
        }
      })
    }
  }, [themeSettingsData])
  return (
    <div style={{color:headerTopData.textColor ? headerTopData.textColor : "", background:headerTopData?.bgColor ? headerTopData.bgColor : themeClass !== "beachTheme" ? "#fff" : ''}}
      className={`header-top-wap ${borderStyle === "fluid-border" ? "border-bottom" : ""
        } ${themeClass ? themeClass : ''} ${themeClass === "beachTheme" ? 'p-0': ''}`}
    >
      {
        headerTopData?.isEnabledfullWidthText != true &&
        <>
          <div className={`header-left-side ${headerTopData.isEnabledCenterText ? 'header-left-height' : ''}`}>
            {headerTopData?.isEnabledLeftText &&
              <div className="header-top-left-con" dangerouslySetInnerHTML={{ __html: headerTopData?.leftTextHtml }}></div>
            }
          </div>
          <div className={`header-center-side ${headerTopData.isEnabledCenterText ? 'header-center-height' : ''}`}>
            {headerTopData.isEnabledCenterText && <div className="header-top-center-con" dangerouslySetInnerHTML={{ __html: headerTopData.centerTextHtml ? headerTopData.centerTextHtml : "" }}></div>}
          </div>

          <div className="header-right-side">
            {headerTopData.isEnabledRightText && <div className="header-offer" dangerouslySetInnerHTML={{ __html: headerTopData.rightTextHtml ? headerTopData.rightTextHtml : "" }}></div>}
          </div>
        </>
      }
    </div>
  );
};

HeaderTop.propTypes = {
  borderStyle: PropTypes.string,
  setCurrency: PropTypes.func,
  currency: PropTypes.object,
  currentLanguageCode: PropTypes.string,
  dispatch: PropTypes.func
};

const mapStateToProps = state => {
  return {
    currency: state.currencyData
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setCurrency: currencyName => {
      dispatch(setCurrency(currencyName));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(multilanguage(HeaderTop));
